import { Stack, Typography } from '@mui/joy';
import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { elementService } from 'bom/services';
import { IElementTemplate } from 'bom/types';
import { FormField } from 'core/components';
import { TextHighlighter } from 'core/elements';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { IRequestPayload } from 'core/types';
import { Level } from 'theme/enums';

interface IProps {
  name?: string;
  label?: string;
  placeholder?: string;
  requestPayload?: IRequestPayload;
  required?: boolean;
  disabled?: boolean;
  onChange?: (element: IElementTemplate | null) => void;
}

export const ElementTemplateFormField = ({
  name = 'elementTemplate',
  label,
  placeholder,
  requestPayload,
  required = false,
  disabled = false,
  onChange,
}: IProps) => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  const renderOptions = (
    option: IElementTemplate,
    _: (option: IElementTemplate) => string,
    inputValue?: string
  ) => {
    return (
      <Stack>
        <TextHighlighter level={Level.TITLE_SM} text={option.description} highlight={inputValue} />

        <Typography level={Level.BODY_XS}>{option.customIdentifier}</Typography>
      </Stack>
    );
  };

  return (
    <FormField
      name={name}
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        control,
        error: errors?.[name],
        optionKey: 'customIdentifier',
        label: label || t('labelElementTemplate'),
        placeholder: placeholder || t('placeholderSelectElementTemplate'),
        getOptions: elementService.getElementTemplatesAutocomplete,
        getLabel: (option: IElementTemplate) => option.description,
        renderOptions,
        onChange: (_: SyntheticEvent, option: IElementTemplate | null) => {
          if (onChange) {
            onChange(option);
          }
        },
        enabledOnFocus: false,
        requestPayload,
        required,
        disabled,
      }}
    />
  );
};
